<script setup lang="ts">
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import { onMounted, ref } from 'vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import ThumbCell from '@/onenetwork/components/datatable/ThumbCell.vue'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import RealestateAPI from '../constants/realestate.api.uri.const'
import { formatTableDataListing } from '../helper/table'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import AddressCell from '@/onenetwork/components/datatable/AddressCell.vue'
import ListingSubjectCell from '@/onenetwork/components/datatable/ListingSubjectCell.vue'
import ListingStatisticCell from '@/onenetwork/components/datatable/ListingStatisticCell.vue'
import AccountCell from '@/onenetwork/components/datatable/AccountCell.vue'

interface Props {
  id: any
  exclude_id: any
}

const props = defineProps<Props>()

const loading = ref<boolean>(false)
const pageSize = ref(10)
const page = ref(1)
const dataSource = ref({
  list: [],
  totalPage: 0,
  totalRecords: 0,
})

const handleChangePage = (page: number) => {
  if (page !== page.value) {
    page.value = page
    requestFetchData()
  }
}

const handleChangePageSize = (size: number) => {
  if (size !== pageSize.value) {
    pageSize.value = size
    page.value = 1 // Reset to first page when changing page size
    requestFetchData()
  }
}

const requestFetchData = async () => {
  try {
    loading.value = true
    const res = await APIClient.get(RealestateAPI.listing.list, {
      params: {
        real_estate_id: props.id || null,
        exclude_id: props.exclude_id || null,
        page: page.value,
        page_size: pageSize.value,
      },
    })
    loading.value = false
    const { data } = res.data
    if (res.data.code === 200) {
      dataSource.value = {
        list: formatTableDataListing(data.data) || [],
        totalPage: data.last_page,
        totalRecords: data.total,
      }
    }
  } catch (e: any) {
    console.log(e)
    loading.value = false
  }
}

onMounted(() => {
  requestFetchData()
})
</script>

<template>
  <data-table
    :loading="loading"
    :tableConfig="{
      canShowHide: false,
      columns: {
        code: {
          label: 'Mã tin',
          component: TextCell,
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        type: {
          label: 'Loại tin',
          component: TagCell,
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        address: {
          label: 'Địa chỉ',
          component: AddressCell,
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        subject: {
          label: 'Thông tin',
          component: ListingSubjectCell,
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        author: {
          label: 'Đăng bởi',
          component: AccountCell,
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        statistic: {
          label: 'Thống kê',
          component: ListingStatisticCell,
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        status: {
          label: 'Trạng thái',
          component: TagCell,
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        regdate: {
          label: 'Ngày đăng ký',
          component: DateTimeCell,
          class: '',
          visible: true,
          sort: '',
          config: {},
        },
      },
    }"
    :page-size="pageSize"
    :page="page"
    :total-page="dataSource?.totalPage || 0"
    :total-records="dataSource?.totalRecords || 0"
    :data="dataSource?.list || []"
    @page-changed="handleChangePage"
    @pagesize-changed="handleChangePageSize"
  />
</template>

<style scoped></style>
